module.exports = __webpack_public_path__ + "img/Car-partial.f3be23af.svg";